// 障害物検知データの型定義
// fork の state トピック内 obstacleHandler と同一構造
// （fork_webapp_react の ObstacleHandlerData と同期）

export interface ObstaclePoint {
  x: number
  y: number
}

export interface ObstacleHandlerData {
  distanceOnTrajectory: number
  angleOnRotationLeft: number
  angleOnRotationRight: number
  isInCriticalAreaFront: boolean
  isInCriticalAreaRear: boolean
  sourceCriticalAreaFront: number
  sourceCriticalAreaRear: number
  sourceTrajectory: number
  sourceRotationLeft: number
  sourceRotationRight: number
  obstaclePointFront: ObstaclePoint | null
  obstaclePointRear: ObstaclePoint | null
  obstaclePointTrajectory: ObstaclePoint | null
}

// エラー発生時の機体位置（ログ context の obstaclePose）
export interface ObstaclePose {
  x: number
  y: number
  theta: number
}

// センサービットとラベルの対応（fork_webapp_react の drawObstacleIndicators と同期）
export const OBSTACLE_SENSOR_LABELS: { bit: number; label: string }[] = [
  { bit: 0x01, label: 'LiDAR左' },
  { bit: 0x02, label: 'LiDAR右' },
  { bit: 0x04, label: 'LiDAR後' },
  { bit: 0x08, label: '爪先端左' },
  { bit: 0x10, label: '爪先端右' },
]

// obstacleHandler の全ソースビットマスクを合成
export function combineObstacleSourceBits(data: ObstacleHandlerData): number {
  return (
    (data.sourceCriticalAreaFront |
      data.sourceCriticalAreaRear |
      data.sourceTrajectory |
      data.sourceRotationLeft |
      data.sourceRotationRight) >>>
    0
  )
}

// ログ context から obstacleHandler を安全に取り出す
export function parseObstacleHandlerFromContext(
  context: Record<string, unknown> | undefined
): { obstacleHandler: ObstacleHandlerData; pose: ObstaclePose | null } | null {
  const oh = context?.obstacleHandler as ObstacleHandlerData | undefined
  if (!oh || typeof oh !== 'object') return null
  if (typeof oh.sourceCriticalAreaFront !== 'number') return null
  const rawPose = context?.obstaclePose as ObstaclePose | undefined
  const pose =
    rawPose && typeof rawPose.x === 'number' && typeof rawPose.y === 'number'
      ? { x: rawPose.x, y: rawPose.y, theta: rawPose.theta ?? 0 }
      : null
  return { obstacleHandler: oh, pose }
}
